'use client'

import { useTranslations } from '@/lib/next-shim'
import { FormSubmissionsList } from '@/shared/ui/form/FormSubmissionsList'
import { ExpertiseFormSubmissions } from '../lib/expertise-detail.types'

type FormsSectionProps = {
  submissions: ExpertiseFormSubmissions
  expertiseId: string
}

export function FormsSection({ submissions, expertiseId }: FormsSectionProps) {
  const t = useTranslations()

  return (
    <div>
      <h2 className="mb-2 text-sm font-medium text-gray-500">{t('page.expertise.forms.title')}</h2>
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <FormSubmissionsList submissions={submissions} contextType="expertise" contextId={expertiseId} />
      </div>
    </div>
  )
}
